export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export const USERNAME_REGEX = /^[A-Za-z0-9@.+_-]+$/;

export const PHONE_REGEX = /^[0-9+-]*$/;

export const ONLY_NUMBER_REGEX = /^\d*$/;
